import { changeRoundStateAction } from 'core/widgets/RoundStates/actions';
import { put } from 'redux-saga/effects';
import { Notifications } from 'types';
import {
  addBettingTimeToastAction,
  removeBettingTimeToastAction,
} from 'core/widgets/Toast/actions';
import { roundStatusMessages } from 'constants/toastMessages';
import { RoundStates } from '../../RoundStates/types';
import { setIsTheLast2SecondsInBettingTimeToStoreAction } from 'core/widgets/BettingTime/actions';
import { changeModeAction } from 'core/widgets/RouletteBet/actions';
import { Modes } from 'widgets/Roulette/types';

export function* onBettingTimeFinishedSaga({ type: notificationType }: any) {
  if (notificationType === Notifications.BETTING_TIME_FINISHED) {
    yield put(changeRoundStateAction({ roundState: RoundStates.BettingTimeFinished }));
    yield put(removeBettingTimeToastAction());
    yield put(
      addBettingTimeToastAction({
        value: roundStatusMessages.BETTING_TIME_FINISHED,
      }),
    );
    yield put(setIsTheLast2SecondsInBettingTimeToStoreAction(false));
    yield put(changeModeAction({ mode: Modes.small }));
  }
}
